export default __webpack_public_path__ + "static/1-9b629ea11df3aac25e4142146133bdcb.png";